const Toast = ({ title }) => <div className='toastify-header pb-0'>
  <div className='title-wrapper'>
    <h6 className='toast-title'>{title}</h6>
  </div>
</div>

export default Toast